import React from 'react';
import { Flex } from '@televet/kibble-ui/build/chakra';
import { Text } from '@televet/kibble-ui/build/components/Text';
import RefreshLink from './RefreshLink';

export const RefreshLinkWithLabel = ({
  onClick,
  isLoading,
  label,
}: {
  onClick: () => void;
  isLoading: boolean;
  label: string;
}): JSX.Element => {
  return (
    <Flex alignItems="center">
      <Text size="sm" fontWeight="bold" mr={2}>
        {label}
      </Text>
      <RefreshLink onClick={onClick} isLoading={isLoading} />
    </Flex>
  );
};
